<template>
  <div class="list-wrapper">
    <div class="header">
      <van-icon name="arrow-left" size="20" color="#fff" @click="goBack" />
    </div>
    <iframe scrolling="no" :src="url" frameborder="0"></iframe>
  </div>
</template>
<script>
import { Loading } from "vant";
import "vant/lib/loading/style";
import record from "../../utils/record.js";
import timeFormats from "../../utils/timeFormat_record.js";

export default {
  data() {
    return {
      url: this.$route.query.url,
      ssoid: localStorage.getItem("ticketObj")?JSON.parse(localStorage.getItem("ticketObj")).sso_id:'',
      phone: JSON.parse(localStorage.getItem("ticketObj")).phone,
      sign: JSON.parse(localStorage.getItem("ticketObj")).sign,
    }
  },
  mounted() {
    this.uprecord()
    if (this.$route.query.module_type == 6) {
      this.update()
      this.url = this.$route.query.url + '&phone=' + this.phone + '&ssoId=' + this.ssoid + '&liveSign=' + JSON.parse(localStorage.getItem("ticketObj")).sign + '&login=1&ext='+ this.phone
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    uprecord() {
      let inTime = new Date().getTime();
      let recordParams = {
        erp_id: this.$route.query.order_id,
        cid: this.$route.query.cid,
        package_id: this.$route.query.package_id,
        course_id: 0,
        unit_id: this.$route.query.unit_id,
        action_time: timeFormats(new Date()/1000),
        start_time: timeFormats(new Date()/1000),
        product: 2,
        is_online: 1,
        live_type: this.$route.query.live_type,
        module_type: this.$route.query.module_type,
        course_type: 1,
        version: 0,
        other: {
          traceID: inTime
        }
      }
      record(recordParams)
    },
    update () {
      let that = this;
      this.recordTimer = setInterval(function () {
        that.uprecord();
      }, 60000);
    }
  },
};
</script>

<style lang="less" scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 10%;
  height: 90px;
  display: flex;
  align-items: center;
  padding: 0 30px 0 25px;
}
iframe {
  width: 100%;
  height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/components/livevod/index.vue